<template>
  <span>
    <div id="app">
      <v-app light>
        <v-toolbar max-height="64px">
          <v-toolbar-title>Bolsa de Trabajo</v-toolbar-title>
          <v-toolbar-title class="text--secondary mx-2 subtitle-1">Establecer Contraseña</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="bolsa-green" text icon :to="{ name: 'Landing' }">
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </v-toolbar>
        <v-main>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="12" md="5">
                <div class="d-flex justify-center">
                  <v-card style="width: 100%" :disabled="cardDisabled">
                    <v-card-text>
                      <v-form lazy-validation ref="formPassword" v-model="validationPassword">
                        <v-text-field
                          v-model="body.passwordNueva"
                          autocomplete="new-password"
                          :type="showPassword ? 'text' : 'password'"
                          label="Nueva Contraseña"
                          placeholder="******"
                          :rules="[
                              () => !!body.passwordNueva || 'La nueva contraseña es obligatoria',
                              () => !!body.passwordNueva && body.passwordNueva.length >= 6 || 'La nueva contraseña debe tener al menos 6 caracteres'
                            ]"
                          prepend-icon="mdi-lock-question"
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          outlined
                          color="bolsa-green"
                          @click:append="showPassword = !showPassword"
                          required
                        ></v-text-field>
                        <v-text-field
                          v-model="body.passwordConfirma"
                          autocomplete="new-password"
                          :type="showConfirmPassword ? 'text' : 'password'"
                          label="Confirmar Nueva Contraseña"
                          placeholder="******"
                          :rules="[
                              () => !!body.passwordConfirma || 'La nueva contraseña es obligatoria',
                              () => !!body.passwordConfirma && body.passwordConfirma == body.passwordNueva || 'Las contraseñas no coinciden',
                              () => !!body.passwordConfirma && body.passwordConfirma.length >= 6 || 'La nueva contraseña debe tener al menos 6 caracteres'
                            ]"
                          prepend-icon="mdi-lock-question"
                          :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          color="bolsa-green"
                          outlined
                          @click:append="showConfirmPassword = !showConfirmPassword"
                          required
                        ></v-text-field>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        :dark="validationPassword"
                        block
                        class="bolsa-green"
                        :disabled="!validationPassword"
                        :loading="fetching"
                        @click="recuperarPassword"
                      >Actualizar Contraseña</v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-col>
              <v-divider :vertical="$vuetify.breakpoint.mdAndUp"></v-divider>
              <v-col
                cols="12"
                sm="12"
                md="6"
                class="d-flex align-center justify-center flex-column"
              >
                <v-alert
                  :type="body.token ? 'info' : 'error' "
                  v-if="infoAlert"
                  style="width: 100%"
                >{{body.token ? 'Una vez actualices la contraseña, podrás acceder a la plataforma' : 'Token Inválido, revisa nuevamente la URL'}}</v-alert>
                <transition name="slide-fade">
                  <v-alert
                    v-if="successAlert"
                    style="width: 100%"
                    type="success"
                  >Contraseña actualizada correctamente, identificate para acceder a la plataforma</v-alert>
                </transition>

                <transition name="slide-fade">
                  <div class="d-flex justify-center" v-if="successAlert">
                    <v-btn :to="{ name: 'Landing' }" color="bolsa-green" dark>
                      Ir a la Página de Inicio
                      <v-icon right dark>mdi-home</v-icon>
                    </v-btn>
                  </div>
                </transition>
                <transition name="slide-fade">
                  <v-alert
                    type="error"
                    v-if="getError.error"
                    style="width: 100%"
                  >{{getError.errorMessage == 'Token expirado' ? 'El token usado ya expiró, contacta con el administrador para recibir ayuda.' : 'Ha sucedido un error al validar la información, actualiza la página e intenta nuevamente.'}}</v-alert>
                </transition>
              </v-col>
            </v-row>
          </v-container>
        </v-main>
      </v-app>
    </div>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      showPassword: false,
      showConfirmPassword: false,
      validationPassword: false,
      isValid: true,
      infoAlert: true,
      successAlert: false,
      body: {
        passwordNueva: "",
        passwordConfirma: "",
        token: ""
      },
      cardDisabled: false
    };
  },

  methods: {
    getToken() {
      return this.$route.query.token;
    },

    async recuperarPassword() {
      if (this.$refs.formPassword.validate()) {
        let response = await this.postRecuperarPassword(this.body);
        this.infoAlert = false;
        if (response.success) {
          this.successAlert = true;
          this.$refs.formPassword.reset();
          this.validationPassword = false;
          this.cardDisabled = true;
        }
      }
    },

    ...mapActions("auth", ["validateToken"]),
    ...mapActions("publicModule", ["postRecuperarPassword"])
  },

  computed: {
    ...mapGetters("user", ["fetching", "getError"])
  },

  mounted() {
    this.body.token = this.getToken();
    this.validationPassword = false;
    console.log(this.body.token);
  }
};
</script>

<style>
html {
  overflow: auto;
}

.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>